var bVatConfirmed = false;
var rAmount       = /^\d+([,.]\d{1,2})?$/;
var rDate         = "[0-9-]{10,10}";
var rEmail        = "^[a-zA-Z0-9-_\+~]+(\.[a-zA-Z0-9-_\+~]+)*@([a-zA-Z_0-9-]+\.)+[a-zA-Z]{2,7}$";
var rNumber       = /^\d+$/;
var rPhone        = "\\+?[0-9.\\-\\(\\) ]+";
var sVatPrevious  = '';

$(function()
{
	// create input masks for all relevant input fields
	if($.isFunction($.fn.inputmask))
	{
		formatInputs();
	}

	// format ez mark styling
	if($.isFunction($.fn.ezMark))
	{
		formatEzMark();
	}

	// phone prefix widget: initialise wherever the markup appears. account.js also calls this on
	// its own ready and after refreshData; the widget is idempotent per wrapper (data('phoneInit')).
	initAccountPhoneFields();

	// needInvoice checkbox listener
	if($('.inputNeedInvoice').length > 0){
		$('.inputNeedInvoice').change(function()
		{
			changeInvoice($(this));
		});
		changeInvoice(null);
	}

	$(el('mainContainer')).on("click", "#popupCustomerPhoneValidation .btnPopupCustomerPhoneValidation", function (e) {
		e.preventDefault();

		var type = $(this).data("type");

		if (type === "replace") {
			// trigger('change') so listeners resync to the rewrite (e.g. the account phone-prefix widget)
			$(el("mainContainer")).find(".validatingNumberViaService").val($(this).data("value")).trigger('change');
		}
		else if (type === "invalid") {
			$(el("mainContainer")).find(".validatingNumberViaService").closest('.control-group').addClass('error').removeClass('success')
		}

		$(el("mainContainer")).find(".validatingNumberViaService").removeClass("validatingNumberViaService");

		$("#popupCustomerPhoneValidation").modal("hide");
	});

	if(bUseValidationServiceForPhoneFields)
	{
		$(el('mainContainer')).on("blur", "input[data-type='phone']", function (e) {
			validatePhoneInput($(this));
		});
	}
});

function changeInvoice()
{
	toggleCompanyInfo();
}

// format ez mark styling
function formatEzMark()
{
	// ezmark styling for radio buttons
	if($('input[type="radio"]').length > 0)
	{
		$('input[type="radio"]').ezMark();
	}
	// ezmark styling for checkboxes
	if($('input[type="checkbox"]').length > 0)
	{
		$('input[type=checkbox]').ezMark();
	}
}

// create input masks for all relevant input fields
function formatInputs()
{
	// dates
	// Inputmask paints its own placeholder over the field once it is focused, which swapped the
	// localised hint (dd-mm-jjjj in NL) for the mask's English dd-mm-yyyy. Reuse whatever the
	// markup already says so the two never disagree; only when it is the same length as the mask.
	$("input[data-type='date']").each(function(){
		var sHint = $(this).attr("placeholder");
		$(this).inputmask("dd-mm-yyyy", (sHint && sHint.length === 10) ? {placeholder: sHint} : {});
	});

	// text only
	$("input[data-type='textOnly']").inputmask({
		'mask': 'a',
		'greedy': false,
		'repeat': '*'
	});

	if(!bUseValidationServiceForPhoneFields)
	{
		// phone numbers
		$("input[data-type='phone']").inputmask('Regex', {regex: rPhone});
	}

	// times
	$("input[data-type='time']").inputmask({ alias: "hh:mm", positionCaretOnTab: false});
}

// set company info required based on selections
function toggleCompanyInfo()
{
	var bNeedInvoice = $('.inputNeedInvoice').prop('checked');

	if(bNeedInvoice === true)
	{
		$('.imCustomerContainer').addClass('hide');
		$('.imCompanyContainer').removeClass('hide');
		$('.inputCompany:visible,.inputDepartment:visible,.inputVat:visible').parents('.control-group').removeClass('invisible');
	}
	else
	{
		$('.inputCompany:visible,.inputDepartment:visible,.inputVat:visible').parents('.control-group').addClass('invisible');
		$('.imCompanyContainer').addClass('hide');
		$('.imCustomerContainer').removeClass('hide');
	}
}

function trueDisableForm(container){

	if(typeof container === 'undefined'){
		container = $('body');
	}

	container.find('input[disabled="disabled"]:not(input[type="checkbox"], input[type="radio"])').each(function(item){
		$(this).parent().html(
			'<label class="control-label">'+$(this).val()+'</label>'
		)
	});

	container.find('select[disabled="disabled"]').each(function(item){
		$(this).parent().html(
			'<label class="control-label">'+$(this).children('option:checked').html()+'</label>'
		);
	});

	container.find('input[disabled="disabled"][type="checkbox"], input[disabled="disabled"][type="radio"]').each(function(item) {
		if($(this).is(':checked')){
			$(this).remove();
		}
		else{
			$(this).parent().remove();
		}

	});

}

function validateEmailString(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

function validateMultipleEmailString(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var emails = email.split(';');
	for (var i = 0; i < emails.length; i++) {
		var email = emails[i].trim();
		if (!re.test(String(email).toLowerCase())) {
			return false;
		}
	}
	return true;
}

// validate a complete form
function validateForm(oForm)
{
	// remove all errors
	oForm.find('.error').removeClass('error');
	oForm.find('.success').removeClass('success');
	$('[id^=fb]').hide();

	// validation
	var bValid = validateRequired(oForm);
	if(validateAmount(oForm) == false)
	{
		bValid = false;
	}
	if(validateBox(oForm) == false)
	{
		bValid = false;
	}
	if(validateEmail(oForm) == false)
	{
		bValid = false;
	}
	if(validateDate(oForm) == false)
	{
		bValid = false;
	}
	if(validateHousenumber(oForm) == false)
	{
		bValid = false;
	}
	if(validatePhone(oForm) == false)
	{
		bValid = false;
	}
	if(validateCheckbox(oForm) == false)
	{
		bValid = false;
	}
	if(validateMinLength(oForm) === false)
	{
		bValid = false;
	}
	// after validateMinLength on purpose: both swap the same slot, and running last means the
	// min-length message is never the copy this one stores to put back
	if(validatePasswordCheck(oForm) == false)
	{
		bValid = false;
	}
	if(validateVAT(oForm) === false)
	{
		bValid = false;
	}
	if(validateDateOfBirth(oForm) === false)
	{
		bValid = false;
	}
	if(validatePsnId(oForm) === false)
	{
		bValid = false;
	}
	return bValid;
}

// check all required fields are filled out
function validateRequired(oForm)
{
	var bValid = true;

	var aFields = oForm.find('input[type!="radio"][required], textarea[required], select[required]');
	var aSets = oForm.data('fields');
	var aValidatedFields = [];

	if( typeof aSets === "undefined"){
		aSets = [];
	}

	for(var i=0; i < aSets.length; i++){
		var oResult = validateSet(aSets[i]);
		aValidatedFields = aValidatedFields.concat(oResult.fields);
		if(oResult.valid === false){
			bValid = false;
		}
	}
	// loop through form elements that are required
	oForm.find('input[type!="radio"][required], textarea[required], select[required]').each(function()
	{
		var bVisible = $(this).is(':visible');
		if($(this).parents(".collapse").length > 0)
		{
			bVisible = ($(this).parents(".collapse").height() > 0);
		}
		if(bVisible && !$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success')){
			// check if empty (and visible)
			if(fieldIsValid($(this)))
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// loop through radios - validate if one is checked
	oForm.find('input[type="radio"][required]').each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success'))
		{
			var sName = $(this).prop('name');
			if(fieldIsChecked($('input[type="radio"][name="' + sName + '"')))
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// loop through checboxes - validate if one is checked
	oForm.find('.checkbox-group.required').each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success'))
		{
			if($(this).find(":checkbox:checked").length > 0)
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbRequired').show();
	}
	return bValid;
}

function validateSet(oSet){
	var aCheckedFields = [];
	var bValid = true;
	var aValidatedSet = [];
	for(var j = 0; j < oSet.set.length; j++){
		if(typeof oSet.set[j] === 'object'){
			var oResult = validateSet(oSet.set[j]);
			aCheckedFields = aCheckedFields.concat(oResult.fields);
			aValidatedSet.push(oResult.valid);
		}
		else{
			var oField = $(oSet.set[j]);
			if(fieldIsValid($(oField)))
			{
				aValidatedSet.push(true);
			}else
			{
				aValidatedSet.push(false);
			}
			aCheckedFields.push(oField);
		}
	}

	switch(oSet.condition.toUpperCase()){
		case 'AND':
			if(aValidatedSet.indexOf(false) !== -1){
				bValid = false;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'error')});
			}
			else{
				bValid = true;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'success')});
			}
			break;
		case 'OR':
			if(aValidatedSet.indexOf(true) !== -1){
				bValid = true;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'success')});
			}
			else{
				bValid = false;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'error')});
			}
			break;
	}

	return {'valid': bValid, 'fields' : aCheckedFields} ;
}

function fieldIsChecked(oField)
{
	return !(!oField.is(':checked') && oField.is(':visible'));
}

function fieldIsValid(oField){
	var sValue = oField.val() || "";
	return !(sValue.trim() == "" && oField.is(':visible'));
}

function resetForm(oForm)
{
	$(':input', oForm).not(':button, :submit, :reset').val('').removeAttr('checked').removeAttr('selected');
}
function setFieldValidationState(oField,sValidationState){
	oField.closest('.control-group').removeClass('error').removeClass('success');
	oField.closest('.control-group').addClass(sValidationState);
}

function validateAmount(oForm)
{
	var bValid   = true;
	var oAmounts = oForm.find('input[data-type="amount"]');
	var iAmount  = 0;

	// loop through inputs fields and validate
	oAmounts.each(function()
	{
		iValue = $(this).val().replace('-', '');
		iValue = parseFloat($(this).val());
		if(!rAmount.test(iValue))
		{
			$(this).closest('.control-group').addClass('error').removeClass('success');
			bValid = false;
		}else
		{
			$(this).closest('.control-group').addClass('success');
		}
	});

	return bValid;
}

// validate a box
function validateBox(oForm)
{
	var bValid  = true;
	var oBox = oForm.find('input[data-type="box"]');

	// loop through email address input fields
	oBox.each(function()
	{
		if($(this).is(':visible'))
		{
			// check if filled in
			if($(this).val().length > 20)
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbHousenumber').show();
	}

	return bValid
}

// validate a checkbox
// this function checks if he checkbox is checked
function validateCheckbox(oForm)
{
	var bValid = true;
	var oCheckboxes = oForm.find('input[data-type="checkbox"]');

	// loop through email address input fields
	oCheckboxes.each(function()
	{
		if(!$(this).is(':checked'))
		{
			$(this).closest('.control-group').addClass('error').removeClass('success');
			bValid = false;
		}
		else
		{
			$(this).closest('.control-group').addClass('success');
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbPhone').show();
	}

	return bValid
}

// check if dates are valid
// this function assumes the input mask already covered the correct date
// it only checks if only numbers are filled in
function validateDate(oForm)
{
	var bValid = true;
	var oDates = oForm.find('input[data-type="date"]');

	// loop through email address input fields
	oDates.each(function()
	{
		// check if filled in
		if($(this).val() != '' && !$(this).hasClass('inputBirthdate'))
		{
			if(RegExp(rDate).test($(this).val()) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbDate').show();
	}

	return bValid
}

// Swaps the field's generic "fill this in correctly" copy for the age message, so a perfectly
// well-formed date does not fail with a message saying the format is wrong. Mirrors
// setMinLengthError: the original copy is stored once and restored by clearMinAgeError.
function setMinAgeError(oGroup, iMinAge)
{
	var sMessage = (typeof tErrMinAge !== 'undefined' && tErrMinAge !== '')
		? tErrMinAge.replace('{min}', iMinAge)
		: '';

	if(sMessage === '')
	{
		return;
	}

	var oSlot = oGroup.find('.help-inline.invalid').first();

	if(oSlot.length)
	{
		if(typeof oSlot.data('minAgeDefault') === 'undefined')
		{
			oSlot.data('minAgeDefault', oSlot.html());
		}
		oSlot.html('<i class="icon-remove"></i>').append(document.createTextNode(sMessage));
	}
}

function clearMinAgeError(oGroup)
{
	var oSlot = oGroup.find('.help-inline.invalid').first();
	if(oSlot.length && typeof oSlot.data('minAgeDefault') !== 'undefined')
	{
		oSlot.html(oSlot.data('minAgeDefault'));
		oSlot.removeData('minAgeDefault');
	}
}

// Same swap as setMinAgeError, for a badly formed address: the field's generic copy says the input
// is invalid without saying why. Falls back to that copy when the key is untranslated.
function setEmailFormatError(oGroup)
{
	var sMessage = (typeof tErrEmail !== 'undefined' && tErrEmail !== '') ? tErrEmail : '';

	if(sMessage === '')
	{
		return;
	}

	var oSlot = oGroup.find('.help-inline.invalid').first();

	if(oSlot.length)
	{
		if(typeof oSlot.data('emailDefault') === 'undefined')
		{
			oSlot.data('emailDefault', oSlot.html());
		}
		oSlot.html('<i class="icon-remove"></i>').append(document.createTextNode(sMessage));
	}
}

function clearEmailFormatError(oGroup)
{
	var oSlot = oGroup.find('.help-inline.invalid').first();
	if(oSlot.length && typeof oSlot.data('emailDefault') !== 'undefined')
	{
		oSlot.html(oSlot.data('emailDefault'));
		oSlot.removeData('emailDefault');
	}
}

function validateDateOfBirth(oForm)
{
	var bValid        = true;
	var oDateOfBirths = oForm.find('input.inputBirthdate,input[data-validation-type="dateofbirth"]');
	var today         = new Date();
	var minDate       = new Date(1900,1,1);

	oDateOfBirths.each(function()
	{
		if($(this).val() !== ""){
			var birthdaySplitted      = $(this).val().split(/(?:\/|\.|-|_| )+/);
			var correctBirthdayFormat = birthdaySplitted[2] + '/' + birthdaySplitted[1] + '/' + birthdaySplitted[0];
			var birthday              = new Date(correctBirthdayFormat);
			var oGroup                = $(this).closest('.control-group');
			var bDateValid            = (birthday instanceof Date && !isNaN(birthday)) && birthday <= today && birthday >= minDate && parseInt(birthday.getDate()) === parseInt(birthdaySplitted[0]);
			var bTooYoung             = false;

			clearMinAgeError(oGroup);

			// Minimum age is opt-in per field (data-min-age). This same validator runs on the account
			// profile and on the kids form, where an 18+ rule would be exactly wrong — so it only
			// applies where the markup asks for it.
			if(bDateValid)
			{
				var iMinAge = parseInt($(this).attr('data-min-age'), 10);
				if(!isNaN(iMinAge))
				{
					// the latest date of birth that still makes someone iMinAge today
					var oLatestAllowed = new Date(today.getFullYear() - iMinAge, today.getMonth(), today.getDate());
					if(birthday > oLatestAllowed)
					{
						bTooYoung  = true;
						bDateValid = false;
						setMinAgeError(oGroup, iMinAge);
					}
				}
			}

			if(!bDateValid)
			{
				oGroup.addClass('error').removeClass('success');
				bValid = false;
			}else
			{
				oGroup.addClass('success').removeClass('error');
			}
		}
	});


	return bValid;
}

// regex check for an e-mail field
function validateEmail(oForm)
{
	var bValid  = true;
	var oEmails = oForm.find('input[data-type="email"]');
	var oEmailLists = oForm.find('input[data-type="emaillist"]');

	// loop through email address input fields
	oEmails.each(function()
	{
		var sEmail  = $(this).val().trim();
		var oGroup  = $(this).closest('.control-group');
		if(sEmail != '')
		{
			if(validateEmailString(sEmail) == false || oGroup.hasClass('error'))
			{
				oGroup.addClass('error').removeClass('success');
				setEmailFormatError(oGroup);
				bValid = false;
			}
			else
			{
				// valid, when trimmed
				$(this).val(sEmail);
				oGroup.addClass('success');
				clearEmailFormatError(oGroup);
			}
		}
		else
		{
			// empty when trimmed
			$(this).val(sEmail);
			clearEmailFormatError(oGroup);
		}
	});

	// loop through email multiple address input fields
	oEmailLists.each(function()
	{
		var sEmails = $(this).val().trim();
		if(sEmails != '')
		{
			if(validateMultipleEmailString(sEmails) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				// valid, when trimmed
				$(this).val(sEmails);
				$(this).closest('.control-group').addClass('success');
			}
		}
		else
		{
			// empty when trimmed
			$(this).val(sEmails);
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbEmail').show();
	}

	return bValid;
}

// validate a house number
function validateHousenumber(oForm)
{
	var bValid  = true;
	var oHousenumbers = oForm.find('input[data-type="housenumber"]');

	// loop through email address input fields
	oHousenumbers.each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success')){
			// check if filled in
			if($(this).val().length > 8)
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbHousenumber').show();
	}

	return bValid
}

// Minimum length, opt-in through the standard HTML minlength attribute (ECOMMA-4039). A field only
// takes part by carrying the attribute, so every existing form validates exactly as it did.
// An empty field is validateRequired's business, not this one: flagging both would put two different
// errors on the same control group.
function validateMinLength(oForm)
{
	var bValid = true;

	oForm.find('[minlength]').each(function()
	{
		var oInput = $(this);
		var oGroup = oInput.closest('.control-group');
		var iMin   = parseInt(oInput.attr('minlength'), 10);

		// a theme could put minlength on a field outside the usual wrapper; fall back to the input's
		// own parent so the message still lands somewhere rather than being dropped silently
		if(!oGroup.length)
		{
			oGroup = oInput.parent();
		}

		// always clear first: a field that was too short a moment ago must read as a normal field
		// again once it is fixed, or once it is emptied and required takes over
		clearMinLengthError(oGroup);

		if(isNaN(iMin) || iMin < 1 || !oInput.is(':visible'))
		{
			return;
		}

		var sValue = oInput.val() || '';
		if(sValue.length === 0 || sValue.length >= iMin)
		{
			return;
		}

		bValid = false;
		oGroup.addClass('error').removeClass('success');
		showMinLengthError(oGroup, iMin);
	});

	return bValid;
}

// The generic slot carries the "this field is required" copy, which is the wrong message for a value
// that is merely too short, so it is swapped out and put back by clearMinLengthError. Views that
// carry no slot at all (the password reset page) get one that is removed again on the next run.
function showMinLengthError(oGroup, iMin)
{
	var sMessage = (typeof tErrMinLength !== 'undefined' && tErrMinLength !== '')
		? tErrMinLength.replace('{min}', iMin)
		: '';

	if(sMessage === '')
	{
		return;
	}

	var oSlot = oGroup.find('.help-inline.invalid').first();

	if(oSlot.length)
	{
		// store the original copy once, so two fields sharing a group can never leave the error text
		// behind as the "default" to restore
		if(typeof oSlot.data('minLengthDefault') === 'undefined')
		{
			oSlot.data('minLengthDefault', oSlot.html());
		}
		oSlot.html('<i class="icon-remove"></i>').append(document.createTextNode(sMessage));
		return;
	}

	var oTarget = oGroup.find('.controls').last();
	if(!oTarget.length)
	{
		oTarget = oGroup;
	}

	$('<span class="help-inline invalid minLengthError"><i class="icon-remove"></i></span>')
		.append(document.createTextNode(sMessage))
		.appendTo(oTarget);
}

function clearMinLengthError(oGroup)
{
	oGroup.find('.minLengthError').remove();

	var oSlot = oGroup.find('.help-inline.invalid').first();
	if(oSlot.length && typeof oSlot.data('minLengthDefault') !== 'undefined')
	{
		oSlot.html(oSlot.data('minLengthDefault'));
		oSlot.removeData('minLengthDefault');
	}
}

// Validate password equals password
function validatePasswordCheck(oForm)
{
	var bValid   		= true;
	var oPassword 		= oForm.find('#inputPassword');
	var oPasswordCheck 	= oForm.find('#inputPasswordCheck');

	if(oPassword.length === 0 || oPasswordCheck.length === 0)
	{
		return bValid;
	}

	// the message goes on the confirmation field, which is the one the visitor is asked to correct;
	// both groups still turn red as before
	var oGroup = oPasswordCheck.closest('.control-group');
	if(!oGroup.length)
	{
		oGroup = oPasswordCheck.parent();
	}

	// always clear first: a corrected pair has to read as a normal field again, and has to do so
	// even when the fields are hidden by the time the form is validated once more
	clearPasswordMatchError(oGroup);

	if(oPassword.is(':visible') && oPasswordCheck.is(':visible') && oPassword.val() !== oPasswordCheck.val())
	{
		bValid = false;
		oPassword.closest('.control-group').addClass('error').removeClass('success');
		oGroup.addClass('error').removeClass('success');
		setPasswordMatchError(oGroup);
	}

	return bValid;
}

// Same swap as setEmailFormatError: the field's generic copy only says the input is invalid, never
// that the two passwords differ. Falls back to that copy while the key is still untranslated.
function setPasswordMatchError(oGroup)
{
	var sMessage = (typeof tErrPasswordMatch !== 'undefined' && tErrPasswordMatch !== '') ? tErrPasswordMatch : '';

	if(sMessage === '')
	{
		return;
	}

	var oSlot = oGroup.find('.help-inline.invalid').first();

	if(!oSlot.length)
	{
		return;
	}

	// a min-length message already in the slot owns the restore, so nothing is stored on top of it
	// and the copy it saved stays the one that comes back
	if(typeof oSlot.data('passwordMatchDefault') === 'undefined' && typeof oSlot.data('minLengthDefault') === 'undefined')
	{
		oSlot.data('passwordMatchDefault', oSlot.html());
	}
	oSlot.html('<i class="icon-remove"></i>').append(document.createTextNode(sMessage));
}

function clearPasswordMatchError(oGroup)
{
	var oSlot = oGroup.find('.help-inline.invalid').first();
	if(oSlot.length && typeof oSlot.data('passwordMatchDefault') !== 'undefined')
	{
		oSlot.html(oSlot.data('passwordMatchDefault'));
		oSlot.removeData('passwordMatchDefault');
	}
}


function validatePhoneInput(oInput)
{
	var sCountryCode = oInput.parents('form').find('select[name="inputCountry"] option:selected').data('code');

	if(typeof sCountryCode === "undefined" || sCountryCode ==="" || sCountryCode === null)
	{
		//fallback to possible data attr on the phone input
		sCountryCode = oInput.data("phoneCountrycode");
	}

	// if country is present , use validationservice
	if(typeof sCountryCode !== "undefined" && sCountryCode !== "" && sCountryCode !== null)
	{
		$(el("mainContainer")).find(".validatingNumberViaService").removeClass("validatingNumberViaService");

		if(oInput.val().trim() !== "")
		{
			var oCall       = validatePhoneCall(sCountryCode, oInput.val().trim());

			oCall.success(function (oData)
			{
				if (oData.validation.valid)
				{
					clearErrors();

					oInput.closest('.control-group').removeClass('error');

					if (oData.validation.confirm)
					{
						oInput.addClass("validatingNumberViaService");

						// confirm the phone number
						$("#popupCustomerPhoneValidation").find(".content").html(oData.html);
						centerPopups();
						$("#popupCustomerPhoneValidation").modal();
					}
					else if (oData.validation.didYouMean !== "" && oData.validation.didYouMean !== oInput.val().trim())
					{
						// fire 'change' so listeners resync to the programmatic rewrite
						// (e.g. the account phone-prefix widget re-absorbs the prefix + recomposes its hidden field).
						oInput.val(oData.validation.didYouMean).trigger('change');
					}
				}
				else
				{
					oInput.closest('.control-group').addClass('error').removeClass('success');
				}
			});
		}
	}
}

// validate a phone number
// this function only checks the characters used, not the actual format
function validatePhone(oForm)
{
	var bValid  = true;
	var oPhones = oForm.find('input[data-type="phone"]');

	// loop through email address input fields
	oPhones.each(function()
	{
		// check if filled in
		if($(this).val() != '')
		{
			if(RegExp(rPhone).test($(this).val()) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbPhone').show();
	}

	return bValid
}

function validatePhoneCall(sCountry, sPhone)
{
	return $.ajax({
		url: "/index.cfm/customer/validation/phone",
		data: "phonenumber=" + encodeURIComponent(sPhone) + "&countrycode=" + sCountry,
		dataType: 'json',
		type: "GET",
		async: false
	});
}

// validate a select box
function validateSelect(oForm)
{
	var bValid  = true;
	var oSelect = oForm.find('select:not(.multi-select)');

	// loop through all select boxes
	oSelect.each(function()
	{
		// check if an option is selected
		if($(this).val() === null)
		{
			$(this).closest('.control-group, .form-group').addClass('error has-error').removeClass('success');
			bValid = false;
		}
		else
		{
			$(this).closest('.control-group, .form-group').addClass('success').removeClass('error has-error');
		}
	});

	return bValid
}

// validate VAT numbers (only for EU at the moment)
function validateVAT(oForm, fCallback, uAjaxVat)
{
	if(typeof uAjaxVat === "undefined"){
		uAjaxVat = '/index.cfm/customer/ajax/validateVat';
	}

	var bValid       	= true;
	var oVat         	= oForm.find('input[name="inputVatNumber"],input[name="inputVat"],input[name="inputInvoiceVat"]');

	// if VAT is visible, and at least the country code is entered
	if(oVat.is(':visible') && oVat.length > 0 && oVat.attr("validationIsNotNeeded") != "true" && oVat.prop('readonly') != true){
		var sVat = oVat.val().trim();
		var sCountryCode = '';

		if($(el('changeAddress')).length)
		{
			sCountryCode = oForm.find('#changeAddress select[name="inputCountry"] option:selected').data('code');
		}
		else if($('.quickCheckoutWrapper').length)
		{
			var oActiveAccordionGroup = $('.activeAccordionGroup');
			sCountryCode = oActiveAccordionGroup.find('select[name="inputInvoiceCountry"]:visible option:selected').data('code');
		}
		else
		{
			sCountryCode = oForm.find('select[name="inputCountry"] option:selected').data('code');
		}

		// substract country code from vat, because the checkvat service takes these as separate parameters
		if(sVat.length > 3 && /^[a-zA-Z]/.test(sVat.substr(0,2))){
			sCountryCode = sVat.substr(0,2);
			sVat = sVat.substr(2).replace(/[^a-z0-9]/gi,'');
		}

		// check if vat changed - if it is, revalidate
		if(sVatPrevious != oVat.val()){
			bVatConfirmed = false;
			sVatPrevious = oVat.val();
		}

		// user has confirmed vat nbr to be valid - continue
		if(bVatConfirmed)
		{
			// assume VAT code is valid by user
			$(this).closest('.control-group, .form-group').addClass('success').removeClass('error has-error');
		}

		// check if filled in code is longer than 3 characters
		else if(sVat.length > 3)
		{
			// asynchronous AJAX call, to make sure tha validation comes through correctly
			$.ajax(
			{
				url: uAjaxVat,
				data: "vat=" + sVat + "&countryCode=" + sCountryCode,
				dataType: 'json',
				type: "GET",
				async: false,
				success: function(oData)
				{
					// check for errors
					if(oData.errorType === 'vat_service')
					{
						if(sVatValidationAllowInvalid == '0')
						{
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');
							showAlert('error', tErrVATValidationServiceNotAllowed, false);
						}
						else
						{
							showAlert('warning', tErrVATValidationService, false);
						}

					}
					else if(oData.errorType !== "")
					{
						if(sVatValidationAllowInvalid == '0')
						{
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');
							showAlert('error', oData.errorMessage, false);
						}
						else
						{
							showAlert('warning', oData.errorMessage, oData.unhandled);
						}
					}
					else if(oData.errorType === 'loggedOut')
					{
						location.reload();
					}
					else
					{
						// call went through
						if(oData.vatServiceResponse.valid == "false")
						{
							// no valid VAT code
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');

							var oPopup = $('#popupContinue');

							if(sVatValidationAllowInvalid == '0' || oPopup.length == 0 || oData.errorType === "icinvalid")
							{
								showAlert('error', tErrVat, false);
							}
							else {
								// configure popup
								setPopupHeader(oPopup, tPopupTitleConfirmVatValid, '');
								oPopup.find('.modal-body .content').html(tPopupTextConfirmVatValid);
								oPopup.find('.action').text(tBtnPopupTextConfirmVatValidContinue).click(function(){
									// user wants vat nbr to be valid: flag vat input as confirmed, and ...
									bVatConfirmed = true;

									// in register page
									if($('#btnRegister:visible').length)
									{
										$('#btnRegister:visible').trigger('click');
									}
									// in account edit
									else if($('#btnUpdateCredentials:visible').length)
									{
										$('#btnUpdateCredentials:visible').trigger('click');
									}
									else if($('#btnUpdateFinancialInfo:visible').length)
									{
										$('#btnUpdateFinancialInfo:visible').trigger('click');
									}

									$(el('popupContinue')).modal('hide');
									oPopup.find('.action,.cancel').unbind('click');
								});
								oPopup.find('.cancel').text(tBtnPopupTextConfirmVatValidCancel).click(function(){
									// unflag so it can be revalidated
									bVatConfirmed = false;

									oPopup.find('.action,.cancel').unbind('click');
								});

								oPopup.modal();
							}
						}
						else
						{
							// valid VAT code
							oVat.closest('.control-group, .form-group').addClass('success').removeClass('error has-error');

							populateFormFromResult(oData.vatServiceResponse);
						}
					}
				},
				error: function()
				{
					showAlert('warning', tErrVATValidationService, false);
				}
			});
		}
		else if(sVat.length > 0)
		{
			// no valid VAT code
			bValid = false;
			oVat.closest('.control-group').addClass('error').removeClass('success');

			var oInlineInvalid = oVat.closest('.control-group').find('.help-inline.invalid');
			if(oInlineInvalid.length)
			{
				oInlineInvalid.html('<i class="icon-remove fa fa-remove"></i>' + tErrVat);
			}
			else
			{
				showAlert('error', tErrVat, false);
			}
		}
	}

	return bValid;
}

// validate psn id
function validatePsnId(oForm)
{
	var bValid = true;
	var psnIds = oForm.find('input[data-type="psnid"]');

	psnIds.each(function()
	{
		if($(this).val() !== "")
		{
			if($(this).val().length < 3 || $(this).val().length > 16)
			{
				bValid = false;
			}
			else if(!/^[A-Z]$/i.test($(this).val().charAt(0)))
			{
				bValid = false;
			}
			else if(!/^[a-zA-Z0-9-_]+$/.test($(this).val()))
			{
				bValid = false;
			}

			if(bValid)
			{
				$(this).closest('.control-group').addClass('success');
			}
			else
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
			}
		}

	});
	return bValid;
}

function populateFormFromResult(oData)
{
	if(typeof oData.box !== 'undefined' && oData.box !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceHousenumber,.inputBox'),oData.box);
	}
	if(typeof oData.city !== 'undefined' && oData.city !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCity,.inputCity'),oData.city);
	}
	if(typeof oData.company !== 'undefined' && oData.company !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCompany,.inputCompany'),oData.company);
	}
	if(typeof oData.houseNumber !== 'undefined' && oData.houseNumber !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceHousenumber,.inputHousenumber'),oData.houseNumber);
	}
	if(typeof oData.postalCode !== 'undefined' && oData.postalCode !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoicePostalcode,.inputPostalcode'),oData.postalCode);
	}
	if(typeof oData.street !== 'undefined' && oData.street !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceStreet,.inputStreet'),oData.street);
	}
	if(typeof oData.vatNumber !== 'undefined' && oData.vatNumber !== "")
	{
		loopAndSet($('#inputInvoiceVat,.inputVat'),oData.vatNumber);
	}
	//NL vatnumber
	if(typeof oData.name !== 'undefined' && oData.name !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCompany,.inputCompany'),oData.name);
	}
}

function loopAndSet(oElem,sData){
	oElem.each(function(iKey,oSubElem){
		$(oSubElem).val(sData);
	});
}

function loopAndSetIfNotEmty(oElem,sData){
	oElem.each(function(iKey,oSubElem){
		if($(oSubElem).val() === "") {
			$(oSubElem).val(sData);
		}
	});
}

// --- phone prefix widget -----------------------------------------------------------------------
// Moved here from modules/customer/scripts/js/account.js in ECOMMA-4027 so the AVA register page
// can use it as well. It lives in form.js because external.min.js loads on every page ahead of the
// module scripts; loading account.js on the register page was not an option, as account.js and
// register.js both define validateRegister, setGenderFromTitles, switchGender and hideOrShowB2C/B2B.
// account.js still calls initAccountPhoneFields() (on ready and after refreshData) and resolves it
// from here.
// Phone prefix + national number compose into the hidden serialised field (#inputPhoneNumber /
// #inputMobileNumber). A value stored without a prefix keeps round-tripping without one until the
// user actively picks a prefix. Idempotent per wrapper — refreshData re-runs it after replacing a pane.
// The prefix is a custom dropdown built into the .accPhonePrefix mount (native <option>s can't render
// the flag images); it holds no name/id so it never enters getValues serialisation.
var aAccountPhonePrefixes = [
	{ code: '+32',  country: 'be' },
	{ code: '+31',  country: 'nl' },
	{ code: '+33',  country: 'fr' },
	{ code: '+49',  country: 'de' },
	{ code: '+352', country: 'lu' },
	{ code: '+44',  country: 'gb' }
];

function initAccountPhoneFields(scope)
{
	$(scope || document).find('.accPhoneField').each(function(){
		var $wrap = $(this);
		if ($wrap.data('phoneInit')) return;
		$wrap.data('phoneInit', true);

		var $prefix      = $wrap.find('.accPhonePrefix'),
			$national    = $wrap.find('.accPhoneNational'),
			$real        = $wrap.find('input[type="hidden"]'),
			hadPrefix    = false,
			// data-force-prefix="true" (AVA register, ECOMMA-4027) treats the default country as
			// an explicit pick, so a number typed into an empty field is stored with its prefix.
			// The account page omits it and keeps the old round-trip behaviour.
			prefixPicked = $wrap.data('forcePrefix') ? true : false,
			sCode        = aAccountPhonePrefixes[0].code;

		// build the dropdown: closed face (flag + code + chevron) and the option list
		var $btn = $('<button type="button" class="accPhonePrefixBtn" aria-haspopup="listbox" aria-expanded="false">' +
			'<span class="accFlag"></span><span class="accPhonePrefixCode"></span></button>')
			.prop('disabled', $real.prop('disabled'));
		var $menu = $('<div class="accPhonePrefixMenu" role="listbox"></div>');
		$.each(aAccountPhonePrefixes, function(i, oPrefix){
			$menu.append('<button type="button" role="option" data-code="' + oPrefix.code + '">' +
				'<span class="accFlag accFlag--' + oPrefix.country + '"></span>' + oPrefix.code + '</button>');
		});
		$prefix.empty().append($btn, $menu);

		function setCode(sNewCode){
			sCode = sNewCode;
			var oMatch = $.grep(aAccountPhonePrefixes, function(o){ return o.code === sNewCode; })[0];
			$btn.find('.accPhonePrefixCode').text(sNewCode);
			$btn.find('.accFlag').attr('class', 'accFlag' + (oMatch ? ' accFlag--' + oMatch.country : ''));
		}

		// longest code first so +352 is matched before +3x
		var aCodes = $.map(aAccountPhonePrefixes, function(o){ return o.code; })
			.sort(function(a, b){ return b.length - a.length; });

		// Strip a leading +CC / 00CC dialling prefix off a value and adopt it as this widget's prefix,
		// returning the national remainder. Used on load (to split the stored number) and again whenever the
		// national field changes under us — notably the phone-validation service rewriting it to an
		// international "didYouMean" — so we never prepend the prefix a second time.
		function absorbPrefix(sVal){
			sVal = $.trim(sVal);
			for (var i = 0; i < aCodes.length; i++) {
				var sIntl = '00' + aCodes[i].slice(1);
				if (sVal.indexOf(aCodes[i]) === 0) { hadPrefix = true; sCode = aCodes[i]; return $.trim(sVal.slice(aCodes[i].length)); }
				if (sVal.indexOf(sIntl) === 0)     { hadPrefix = true; sCode = aCodes[i]; return $.trim(sVal.slice(sIntl.length)); }
			}
			return sVal;
		}

		$national.val(absorbPrefix($real.val()));
		setCode(sCode);

		function compose(){
			// store the app-canonical 00CC form (e.g. "0032496484949") — same as quickcheckout writes —
			// not "+32 …". sCode is "+32" → "00"+"32". National is kept space-free to match.
			var sNational = $.trim($national.val()).replace(/\s+/g, '');
			var bPrefix   = (hadPrefix || prefixPicked) && sNational.length > 0;

			// national trunk code: "0474 ..." is "+32 474 ...", never "+32 0474 ...". Only
			// stripped when a prefix is actually applied, so a bare local number is stored untouched.
			if (bPrefix && sNational.charAt(0) === '0') { sNational = sNational.slice(1); }

			$real.val(bPrefix && sNational.length ? '00' + sCode.slice(1) + sNational : sNational);
		}
		// keystrokes just recompose; a committed change (native blur, or the validation service's didYouMean
		// rewrite which form.js triggers as a 'change') first re-absorbs any prefix the new value carries.
		$national.on('input', compose);
		$national.on('change', function(){
			var sBefore   = $.trim($national.val());
			var sNational = absorbPrefix(sBefore);
			if (sNational !== sBefore) { $national.val(sNational); setCode(sCode); prefixPicked = true; }
			compose();
		});

		// Country "leads" the phone prefix: expose a setter so the address-country <select> can snap this
		// widget's prefix to the matching calling code. Treated as an explicit pick (prefixPicked) so it
		// composes into the saved value. Unknown countries (outside aAccountPhonePrefixes) leave it untouched.
		$wrap.data('setPrefixByIso', function(sIso){
			var oMatch = $.grep(aAccountPhonePrefixes, function(o){ return o.country === sIso; })[0];
			if (!oMatch || $btn.prop('disabled')) return;
			prefixPicked = true;
			setCode(oMatch.code);
			compose();
		});

		function toggleMenu(bOpen){
			$menu.toggleClass('open', bOpen);
			$btn.attr('aria-expanded', bOpen ? 'true' : 'false');
		}
		$btn.on('click', function(){ toggleMenu(!$menu.hasClass('open')); });
		$menu.on('click', 'button', function(){
			prefixPicked = true;
			// attr, not data(): jQuery data() would coerce "+32" to the number 32
			setCode($(this).attr('data-code'));
			compose();
			toggleMenu(false);
			$btn.trigger('focus');
		});
		$prefix.on('keydown', function(e){
			if (e.key === 'Escape') { toggleMenu(false); $btn.trigger('focus'); }
			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();
				if (!$menu.hasClass('open')) toggleMenu(true);
				var $items = $menu.find('button'),
					iAt = $items.index(document.activeElement),
					iNext = iAt + (e.key === 'ArrowDown' ? 1 : -1);
				$items.eq(Math.max(0, Math.min($items.length - 1, iNext))).trigger('focus');
			}
		});
	});
}
